import { Trans } from '@lyearn/i18n';
import { AddMenuSurvey, SurveyOutline } from '@lyearn/icons';
import { addMenuItemType, createReactExtension, PerformanceType } from '@lyearn/lygo-core';

import InlinePlayerToggle from './components/InlinePlayerToggle';

const surveyExtension = createReactExtension({
  name: 'ly__survey',
  attrs: {
    contentId: {
      default: null,
    },
    inlinePlayer: {
      default: false,
    },
  },
  Component: (props) => {
    const { attrs, ...rest } = props;
    const Component =
      require('@/modules/corporate/modules/course/components/SurveyCardContainer').default;
    return <Component {...attrs} {...rest} />;
  },
  menuItem: [
    {
      name: 'ly__survey',
      title: <Trans i18nKey="Common:ResourceType.Survey" />,
      icon: SurveyOutline,
      addMenuIcon: AddMenuSurvey,
      addMenuItemType: addMenuItemType.contents,
      description: <Trans i18nKey="Admin:Contents.SurveyDescription" />,
      searchWords: ['survey', 'assessments'],
    },
  ],
  advancedMenuItem: {
    name: 'ly__survey',
    title: 'Survey Settings',
    components: [
      {
        name: 'inline_player',
        component: InlinePlayerToggle,
        isEnabled: (node) => !!node.attrs.contentId,
      },
    ],
  },
  performanceType: PerformanceType.BLOCK_BASED,
});

export default surveyExtension;
